
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Carrentalinrevetpune() {



    const cardData =
    {
        keyword: 'Car Rental in Ravet Pune',
        heading: 'Platinum24 Cabs: Car Rental in Ravet Pune',
        headingDescription: ' Platinum24 Cabs provides convenient Car Rental in Ravet Pune, offering safe, comfortable, and affordable travel solutions for residents, professionals, and students in this growing PCMC locality. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures smooth rides for local commutes, airport transfers, weekend getaways, and outstation trips. With professional chauffeurs, transparent pricing, and 24/7 availability, we make car rental in Ravet completely hassle-free. Whether it’s a family outing, business trip, or daily travel, Platinum24 Cabs guarantees clean vehicles, punctual service, and dependable car rental options in Ravet Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


        "services": [
    {
      "name": "Ravet Pune Car Rental",
      "description": "Explore Ravet and surrounding areas conveniently with our Ravet Pune Car Rental service. Choose from a wide range of well-maintained vehicles including hatchbacks, sedans, SUVs, and luxury cars — all available for short or long-term rentals. Whether you're a local resident or visiting Pune, our car rental service offers a flexible and affordable transport solution with seamless booking and 24x7 customer support."
    },
    {
      "name": "Car Hire Ravet Pune",
      "description": "Hire a car in Ravet Pune with ease through our quick and reliable service. Our Car Hire Ravet Pune option caters to all types of travelers — from solo riders to family groups, providing comfortable and fuel-efficient cars with or without a driver. Ideal for weddings, business meetings, weekend trips, and more, our services ensure top-notch quality and customer satisfaction every time."
    },
    {
      "name": "Ravet Car Rental Service",
      "description": "Our Ravet Car Rental Service is perfect for local commutes, intercity travel, or long-term rentals. We offer a wide selection of vehicles that are thoroughly cleaned, regularly serviced, and come with optional driver services. Whether you need a car for a few hours or several days, our rental service in Ravet is built around affordability, reliability, and transparency."
    },
    {
      "name": "Affordable Car Rental Ravet",
      "description": "Travel smart with our Affordable Car Rental in Ravet. Designed for budget-conscious customers, our fleet includes economical models that provide comfort and efficiency without breaking the bank. Enjoy transparent pricing, no hidden charges, and the flexibility to choose from daily, weekly, or monthly rental plans with or without a chauffeur."
    },
    {
      "name": "Ravet Car Hire with Driver",
      "description": "Relax and let us drive you with our Ravet Car Hire with Driver service. This option is great for visitors, professionals, and families who prefer chauffeur-driven convenience. Our experienced drivers are punctual, polite, and familiar with local routes — making your travel experience safe and stress-free."
    },
    {
      "name": "Ravet Rental Cars",
      "description": "Choose from a wide variety of Ravet Rental Cars tailored to your journey. Whether you’re heading for a weekend getaway, attending a business event, or simply exploring the city, our reliable rental cars are available at competitive rates. Book online or via phone with doorstep delivery options available."
    },
    {
      "name": "Ravet Car Rental Packages",
      "description": "Save more with our customizable Ravet Car Rental Packages. We offer daily, hourly, weekend, and long-term packages for personal and business use. Add-ons like extra kilometers, fuel-inclusive options, and premium vehicle upgrades are also available for a tailored rental experience."
    },
    {
      "name": "Ravet Rent a Car",
      "description": "Looking to rent a car in Ravet? Our 'Ravet Rent a Car' service makes it simple. Just pick your vehicle, select your rental duration, and hit the road. Ideal for students, working professionals, or families needing temporary mobility, our rentals are backed by insurance, assistance, and affordability."
    },
    {
      "name": "Ravet Car Rental Deals",
      "description": "Unlock the best savings with exclusive Ravet Car Rental Deals. Get discounts on early bookings, festive season offers, weekend rates, and referral rewards. We make renting a car in Ravet budget-friendly while maintaining high service standards."
    },
    {
      "name": "Ravet Self Drive Car Rental",
      "description": "Enjoy total freedom with our Ravet Self Drive Car Rental service. Pick up your car and explore the city or head out for a road trip — all on your own terms. Our self-drive options come with flexible mileage, privacy, and full sanitization to ensure both safety and convenience."
    },
    {
      "name": "Ravet Car Rental for Corporate",
      "description": "Our Ravet Car Rental for Corporate service offers tailored solutions for businesses of all sizes. From daily employee pickups to executive car rentals for client visits and meetings, we ensure timely and professional service. GST billing, monthly invoicing, and long-term lease options available."
    },
    {
      "name": "Ravet Luxury Car Rental",
      "description": "Make a statement with our Ravet Luxury Car Rental services. Choose from high-end models like BMW, Audi, or Mercedes for weddings, VIP guests, or special events. Our luxury rentals offer style, comfort, and sophistication with or without a driver."
    },
    {
      "name": "Ravet Car Rental Online",
      "description": "Book your car anytime from anywhere with Ravet Car Rental Online. Our user-friendly platform allows instant booking, vehicle selection, and online payment with confirmation in minutes. 24x7 customer support is available to assist you throughout your rental experience."
    },
    {
      "name": "Ravet Taxi Service",
      "description": "In addition to rentals, we also offer a dependable Ravet Taxi Service for local and outstation travel. Our taxis are driven by experienced drivers and available around the clock for one-way, round-trip, and hourly bookings at affordable fares."
    },
    {
      "name": "Ravet Car Rental 24x7",
      "description": "Need a car at odd hours? Our Ravet Car Rental 24x7 service ensures vehicles are available for immediate booking anytime, day or night. Whether it’s an emergency trip or late-night airport drop, count on us for prompt and professional service."
    }
  ],
  "tableData": [
    ["Ravet Pune Car Rental", "Car Hire Ravet Pune"],
    ["Ravet Car Rental Service", "Affordable Car Rental Ravet"],
    ["Ravet Car Hire with Driver", "Ravet Rental Cars"],
    ["Ravet Car Rental Packages", "Ravet Rent a Car"],
    ["Ravet Car Rental Deals", "Ravet Self Drive Car Rental"],
    ["Ravet Car Rental for Corporate", "Ravet Luxury Car Rental"],
    ["Ravet Car Rental Online", "Ravet Taxi Service"],
    ["Ravet Car Rental 24x7", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Trusted Car Rental Service in Ravet Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable and affordable car rental services in Ravet Pune for all your travel needs."
    },
    {
      "WhyChooseheading": "Wide Range of Well-Maintained Vehicles",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers to suit your group size and preferences."
    },
    {
      "WhyChooseheading": "Clean and Sanitized Cars for Your Safety",
      "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to ensure a safe and comfortable ride."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Ravet and Surroundings",
      "WhyChoosedescription": "Our professional drivers know the best routes to provide smooth and timely travel."
    },
    {
      "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy transparent fares that include fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Our dedicated team is available round the clock to assist with all your car rental needs."
    },
    {
      "WhyChooseheading": "Flexible Rental Packages for Short and Long Term",
      "WhyChoosedescription": "Choose hourly, daily, or long-term rental plans tailored to your travel requirements."
    },
    {
      "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
      "WhyChoosedescription": "Book your car rental quickly and securely through our website or app with real-time updates."
    }
  ]






























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer car rental services in Ravet Pune?',
        answer: 'Yes, Platinum24 Cabs provides reliable and flexible car rental services in Ravet Pune for both short-term and long-term needs.',
    },
    {
        question: 'How can I book a car rental in Ravet Pune with Platinum24 Cabs?',
        answer: 'You can easily book your car rental through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for car rental in Ravet Pune?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars to meet your rental requirements.',
    },
    {
        question: 'Can I rent a car for local travel as well as outstation trips from Ravet Pune?',
        answer: 'Yes, Platinum24 Cabs offers car rental services for both local travel within Ravet and outstation trips.',
    },
    {
        question: 'Are the drivers experienced and familiar with Ravet Pune routes?',
        answer: 'Absolutely, our drivers are professional, licensed, and knowledgeable about Ravet Pune and nearby areas.',
    },
    {
        question: 'Is hourly and daily car rental available in Ravet Pune?',
        answer: 'Yes, we provide flexible hourly and daily car rental packages tailored to your needs.',
    },
    {
        question: 'Are safety and hygiene protocols followed for car rental vehicles in Ravet Pune?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety measures to ensure passenger safety.',
    },
    {
        question: 'Is car rental service in Ravet Pune available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 car rental booking and services in Ravet Pune.',
    },
    {
        question: 'What payment options are accepted for car rental bookings in Ravet Pune?',
        answer: 'We accept cash, digital wallets, UPI, and card payments for seamless transactions.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Ravet Pune for car rental?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Ravet Pune as per your travel plans.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rahul Deshmukh',
        feedback: 'The car rental service in Ravet Pune by Platinum24 Cabs was hassle-free and comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Sharma',
        feedback: 'Excellent experience with car rental in Ravet Pune. The driver was professional and punctual.',
        rating: 5,
    },
];



































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const ravetCarRentalSchema = {
  "@context": "https://schema.org",
  "@type": "CarRental",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable car rental service in Ravet Pune offering car hire with driver, self-drive options, luxury cars, corporate rentals, and 24x7 service.",
  "areaServed": {
    "@type": "Place",
    "name": "Ravet Pune"
  },
  "serviceType": [
    "Ravet Pune Car Rental",
    "Car Hire Ravet Pune",
    "Ravet Car Rental Service",
    "Affordable Car Rental Ravet",
    "Ravet Car Hire with Driver",
    "Ravet Rental Cars",
    "Ravet Car Rental Packages",
    "Ravet Rent a Car",
    "Ravet Car Rental Deals",
    "Ravet Self Drive Car Rental",
    "Ravet Car Rental for Corporate",
    "Ravet Luxury Car Rental",
    "Ravet Car Rental Online",
    "Ravet Taxi Service",
    "Ravet Car Rental 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};








    return (
        <div>
<Helmet>
  <title>Car Rental in Ravet Pune | Affordable Ravet Car Hire Service</title>
  <meta
    name="description"
    content="Affordable and reliable car rental service in Ravet Pune offering car hire with driver, self-drive options, luxury cars, corporate rentals, and 24x7 service."
  />
  <meta
    name="keywords"
    content="Ravet Pune Car Rental, Car Hire Ravet Pune, Ravet Car Rental Service, Affordable Car Rental Ravet, Ravet Car Hire with Driver, Ravet Rental Cars, Ravet Car Rental Packages, Ravet Rent a Car, Ravet Car Rental Deals, Ravet Self Drive Car Rental, Ravet Car Rental for Corporate, Ravet Luxury Car Rental, Ravet Car Rental Online, Ravet Taxi Service, Ravet Car Rental 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(ravetCarRentalSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/80.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Carrentalinrevetpune;